module.exports = __webpack_public_path__ + "static/WEDDING E&M-463-f735cb40cd2731f7729c8bad6c261908.jpg";